import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bus, Car, Search, Clock } from 'lucide-react';
import { isSharedTransfersEnabled } from '../config/features';

// App-style bottom navigation, mobile only. Launch products (and My Trips)
// stay one tap away on every page so nobody has to hunt for them. Shared
// Transfers appears only when its launch flag is enabled.
const TABS = [
  { path: '/bus', label: 'Bus Tickets', icon: Bus },
  { path: '/private-transfer', label: 'Private', icon: Car },
  { path: '/trips', label: 'Shared', icon: Search, sharedOnly: true },
  { path: '/my-trips', label: 'My Trips', icon: Clock },
].filter((tab) => !tab.sharedOnly || isSharedTransfersEnabled());

const MobileTabBar = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-[#E8DED1] shadow-[0_-2px_8px_rgba(0,0,0,0.06)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      <div className="grid" style={{ gridTemplateColumns: `repeat(${TABS.length}, minmax(0, 1fr))` }}>
        {TABS.map(({ path, label, icon: Icon }) => {
          const active = isActive(path);
          return (
            <Link
              key={path}
              to={path}
              className={`flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                active ? 'text-[#A44432]' : 'text-[#7A6E67]'
              }`}
            >
              <Icon size={20} strokeWidth={active ? 2.4 : 2} />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabBar;
